export default "__VITE_ASSET__DGE2lUxP__"